import { useState } from "react";
import { faqs } from "@/mocks/manga";

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqs[0].id);

  return (
    <section id="faq" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="mb-3 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-500">
            <span className="h-px w-8 bg-primary-400" aria-hidden="true"></span>
            常见问题
            <span className="h-px w-8 bg-primary-400" aria-hidden="true"></span>
          </p>
          <h2 className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            关于《恋爱辅助器》的常见疑问
          </h2>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((f) => {
            const open = openId === f.id;
            return (
              <div
                key={f.id}
                className="overflow-hidden rounded-2xl border border-background-200/80 bg-background-50"
              >
                <button
                  type="button"
                  aria-expanded={open}
                  onClick={() => setOpenId(open ? null : f.id)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className="font-heading text-base font-bold text-foreground-950">{f.q}</h3>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-transform duration-300 ${
                      open ? "rotate-180 bg-primary-500 text-white" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg" aria-hidden="true"></i>
                  </span>
                </button>
                {open && (
                  <p className="border-t border-dashed border-background-200 px-5 py-4 text-sm leading-7 text-foreground-700">
                    {f.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}